<lib-card>
  <ng-container title>Valutazione in corso...</ng-container>

  <ng-container content>
    <div class="flex flex-col gap-4 pt-4">
      @let p = progress();
      @if (p) {
        <p class="text-sm text-gray-500">{{ p.message }}</p>
        <p-progressbar
          [value]="p.progressPercentage"
          [showValue]="true"
        ></p-progressbar>
        <span
          class="w-fit rounded-full px-2 py-0.5 text-xs font-semibold uppercase"
          [class]="statusClass()"
        >
          {{ statusLabel() }}
        </span>
      } @else {
        <p class="text-sm text-gray-500">
          In attesa di risposta dal server...
        </p>
        <p-progressbar mode="indeterminate"></p-progressbar>
      }
    </div>
  </ng-container>
</lib-card>
